// AI Generated Service
import { Injectable } from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';

/**
 * Get details for QA Important Highlights
 */
@Injectable({
    providedIn: 'root',
})
export class QAImportantHighlightsService {
    constructor (
        private sessionService: SessionService,
        private translateService: TranslateService,
        private activeFeatureService: ActiveFeatureService,
    ) {}

    /**
     * Get description for Broken links
     */
    getBrokenLinkText (): string {
        if (this.hasDomainScan()) {
            return this.translateService.getString('Broken link affecting most content');
        }

        return this.translateService.getString('Broken link affecting most pages');
    }

    /**
     * Get description for Broken images
     */
    getBrokenImageText (): string {
        if (this.hasDomainScan()) {
            return this.translateService.getString('Broken image affecting most content');
        }
        return this.translateService.getString('Broken image affecting most pages');
    }

    /**
     * Get api search type for broken links and images
     */
    getLinkSearchType (): string {
        if (this.hasDomainScan()) {
            return 'all';
        }
        return 'html';
    }

    /**
     * Check if broken link should be shown in Important Highlights
     */
    showBrokenLink (brokenLink: any): boolean {
        if (!brokenLink || !this.activeFeatureService.isFeatureActivePure('qa_links')) {
            return false;
        }

        return brokenLink.html_pages_count > 0 || (this.hasDomainScan() && brokenLink.documents_count > 0);
    }

    /**
     * Check if broken image should be shown in Important Highlights
     */
    showBrokenImage (brokenImage: any): boolean {
        if (!brokenImage || !this.activeFeatureService.isFeatureActivePure('qa_links')) {
            return false;
        }

        return brokenImage.html_pages_count > 0 || (this.hasDomainScan() && brokenImage.documents_count > 0);
    }

    // PROTECTED

    /**
     * Check if domain has scan documents
     */
    private hasDomainScan (): boolean {
        return this.sessionService.domain !== null &&
               this.sessionService.domain?.scan?.scan_documents === true;
    }
}
